import { render, staticRenderFns } from "./SearchHistoryAutoPlayHeader.vue?vue&type=template&id=05d32562&scoped=true&"
import script from "./SearchHistoryAutoPlayHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchHistoryAutoPlayHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SearchHistoryAutoPlayHeader.vue?vue&type=style&index=0&id=05d32562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d32562",
  null
  
)

export default component.exports